import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { uploadImage } from '../../services/CommonServices';

const UploaderContainer = styled.div`
  border: 2px dashed #555;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  background-color: #2a2a2a;
  color: #ccc;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    border-color: #007bff;
    background-color: #333;
  }
`;

const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 200px;
  margin-top: 10px;
  border-radius: 4px;
`;

const HiddenInput = styled.input`
  display: none;
`;

const ImageUploader = ({ onUploadSuccess, folder = 'uploads', initialUrl }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [preview, setPreview] = useState(initialUrl);
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // 미리보기 설정
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
    };
    reader.readAsDataURL(file);

    // 업로드 시작
    setIsUploading(true);
    try {
      const response = await uploadImage(file, folder);
      if (response.data.success) {
        onUploadSuccess(response.data.data.url);
      } else {
        alert('Upload failed: ' + response.data.message);
        setPreview(initialUrl); // 실패 시 미리보기 롤백
      }
    } catch (error) {
      console.error('Upload error:', error);
      alert('Upload failed');
      setPreview(initialUrl);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="mb-2">
      <UploaderContainer onClick={handleClick}>
        {isUploading ? (
          <span>Uploading...</span>
        ) : preview ? (
          <>
            <PreviewImage src={preview} alt="Preview" />
            <div style={{ marginTop: '5px', fontSize: '0.8rem' }}>Click to change</div>
          </>
        ) : (
          <span>Click to upload image</span>
        )}
      </UploaderContainer>
      <HiddenInput
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept="image/*"
      />
    </div>
  );
};

export default ImageUploader;

